import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const addCompany = (company, token) => {
  const config = configurationForToken(token);
  return apiClient.post("/admin/company/create", company, config);
};

const updateCompany = (company, token) => {
  const config = configurationForToken(token);
  return apiClient.put("/admin/company/edit", {
    address: company.address,
    contact: company.contact,
    email: company.email,
    id: company.id,
    name: company.name,
    telephone: company.telephone
  }, config);
};

const deleteCompany = (companyId, token) => {
  const config = configurationForToken(token);
  return apiClient.delete("/admin/company/delete", { data: {id: companyId}, ...config });
};

const allCompanies = (token) => {
  const config = configurationForToken(token);
  return apiClient.get("/admin/company/all", config);
};

export default {
  addCompany,
  updateCompany,
  deleteCompany,
  allCompanies,
};



// WEBPACK FOOTER //
// ./src/Services/CompanyService.js